import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MachineApiService {

  constructor(private http: HttpClient) { }
    /*** ---------duplikace putMachineType v machine-column-dialog.component----- */
    /*** MachineList */
    public postMachine(params): Observable<any> {
        return this.http.post('/api/machine-list', params);
    }

    public getMachineListByType(typeId, params): Observable<any> {
        return this.http.get('/api/machine-list/type/' + typeId, {params: params});
    }

    public getMachine(id): Observable<any> {
        return this.http.get('/api/machine-list/' + id);
    }

    public putMachine(id, params): Observable<any> {
        return this.http.put('/api/machine-list/' + id, params);
    }

    public deleteMachine(id): Observable<any> {
        return this.http.delete('/api/machine-list/' + id);

    }

    public putMachineUpdate(id, params): Observable<any> {
        return this.http.put('/api/machine-list/' + id, params);
    }

    public downloadMachineList(typeId: string): Observable<any> {
        return this.http.get('/api/machine-pdf', {
            params: {typeId: typeId},
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }


    /*** MachineType */
    public getMachineType(): Observable<any>{
        return this.http.get('/api/machine-type');
    }

    public postMachineType(data): Observable<any>{
        return this.http.post('/api/machine-type', data);
    }

    public putMachineType(id, data): Observable<any>{
        return this.http.put('/api/machine-type/' + id, data);
    }

    public deleteMachineType(id): Observable<any> {
        return this.http.delete('/api/machine-type/' + id);

    }


    /*** MachineColumn */
    public getMachineColumn(): Observable<any> {
        return this.http.get('/api/machine-column');
    }



}
